import { environment } from "src/environments/environment";
import { RSCBase } from "./base/RSCBase";

class RSCUserPrivilegesSubItem {

    privs: any;
    constructor(privs: any) {
        this.privs = privs || {};
    }

    HasPriv(action: string) {
        try {
            return (environment.disabledPrivilegesChecker || !!this.privs?.[action]);
        } catch (e) {
            return (environment.disabledPrivilegesChecker || false);
        }
    }

}

export class RSCUserPrivilegesFor {

    privs: any;
    constructor(privs: any) {
        this.privs = privs || {};
    }

    HasPriv(action: string) {
        try {
            return (environment.disabledPrivilegesChecker || !!this.privs?.privs?.[action]);
        } catch (e) {
            return (environment.disabledPrivilegesChecker || false);
        }
    }

    SubItem(subItemType: string) {
        return new RSCUserPrivilegesSubItem(this.privs?.sub_items?.[subItemType]);
    }

}

export class RSCUserPrivileges extends RSCBase {

    consolidated: any;

    PrivsFor(_for: string) {
        return new RSCUserPrivilegesFor(this.consolidated?.[_for] || {});
    }

    override toJSON(): any {
        return {};
    }

}
